var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.enigme === 'le-comte-de-minuit')?_c('NewYear'):_vm._e(),(_vm.enigme === 'lestrade')?_c('Gipsy'):_vm._e(),(_vm.enigme === 'escape')?_c('Escape'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }